import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

// Simple label/value list used by every statement block.
export const ReportBlock = ({ titleKey, items, testId, tone }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="p-5" data-testid={testId}>
      <p className="label-xs mb-3">{t(titleKey)}</p>
      <dl className="grid gap-2">
        {items.map(({ key, value, strong }) => (
          <div key={key} className="flex items-center justify-between gap-3" data-testid={`${testId}-${key}`}>
            <dt className={`text-xs ${strong ? "font-bold" : "text-muted-foreground"}`}>{t(`acct.report.${key}`)}</dt>
            <dd className={`font-mono ${strong ? "text-base font-bold" : "text-sm"} ${strong && tone ? tone : ""}`} dir="ltr">
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </NeuCard>
  );
};
